import { parentApi } from '@mathflat/domain/Parent'
import { type Student, studentApi } from '@mathflat/domain/Student'

import { loadInitialData } from '~/@app/init/loadInitialData'
import { commonRepo } from '~/@common/services/repo.service'
import { localStorageService } from '~/@common/services/storage.service'

/**
 * 학부모 토큰만으로는 화면이 서지 않는다 — 활성 자녀가 정해져야 GNB·권한이 선다.
 * 실패는 예외 대신 null 로 돌려주므로 호출부가 세션 정리 방식을 정한다.
 */
export const seedParentSession = async (
  parentUserId: string,
  restrictions?: string[],
): Promise<Student['id'] | null> => {
  try {
    const { studentIds } = await parentApi.getParentChildren(parentUserId)
    const firstStudentId = studentIds[0] as Student['id'] | undefined
    if (!firstStudentId) return null

    localStorageService.update({ user: { studentId: firstStudentId } })

    const students = await studentApi.getStudentsByIds(studentIds as Student['id'][])
    commonRepo.parent.setChildStudents(
      students.map((s) => ({ studentId: s.id as Student['id'], name: s.name ?? '' })),
    )
    commonRepo.parent.setActiveChildStudentId(firstStudentId)

    await loadInitialData(firstStudentId, restrictions)

    return firstStudentId
  } catch {
    return null
  }
}

/** 활성 자녀 id 만 바꾸면 commonRepo.student·앱 설정이 이전 자녀로 남는다 — 새로고침과 같은 경로로 다시 불러온다. */
export const switchParentChild = async (studentId: Student['id']) => {
  if (studentId === commonRepo.parent.activeChildStudentId) return

  commonRepo.parent.setActiveChildStudentId(studentId)
  if (commonRepo.parent.activeChildStudentId !== studentId) return

  await loadInitialData(studentId)
}
